export default __webpack_public_path__ + "static/media/01.0a60aaaa.jpg";